import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { Stack, SxProps } from '@mui/system'
import React from 'react'

interface UserLevelTagProps {
  isVisibleUser: boolean
  isVisibleInstallerPartner: boolean
  sx?: SxProps
}

/**
 * Displays a tag indicating the user levels that have access to a document or category.
 */
const UserLevelTag: React.FC<UserLevelTagProps> = ({ isVisibleUser, isVisibleInstallerPartner, sx }) => {
  return (
    <Stack direction="row" spacing={1} sx={sx}>
      {!isVisibleUser && !isVisibleInstallerPartner && (
        <Typography variant="body2" noWrap>
          {'files.user-level-tag.service-only'}
        </Typography>
      )}
      {isVisibleUser && (
        <Typography variant="body2" noWrap>
          {'files.user-level-tag.user'}
        </Typography>
      )}
      {isVisibleInstallerPartner && (
        <Typography variant="body2" noWrap>
          {'files.user-level-tag.installer-partner'}
        </Typography>
      )}
    </Stack>
  )
}

export default UserLevelTag
